import { Component } from '@verndale/core';
import { WistiaVideoType } from '../../@types/global';

class mediaCarouselCard extends Component {
  videoId: string;
  video: WistiaVideoType | undefined;

  constructor(el: HTMLElement) {
    super(el);
    this.videoId = this.el.dataset.videoId || '';
    if (this.videoId) {
      this.initVideo();
    }
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      videoWrapper: this.el.querySelector<HTMLElement>('.video__iframe-wrapper'),
      playButton: this.el.querySelector<HTMLElement>('.btn.media-carousel-card__video-play'),
      title: this.el.querySelector<HTMLElement>('.media-carousel-card__heading'),
      pictureEl: this.el.querySelector<HTMLElement>(
        '.media-carousel-card__media-wrapper .picture'
      )
    };
  }

  addListeners() {
    if (this.dom.playButton) {
      (this.dom.playButton as HTMLElement).addEventListener('click', this.playVideo.bind(this));
    }
  }

  disableInteractions() {
    const videoWrapper = this.dom.videoWrapper as HTMLElement;
    videoWrapper.style.display = 'none';
  }

  enableInteractions() {
    const videoWrapper = this.dom.videoWrapper as HTMLElement;
    videoWrapper.style.display = 'block';
  }

  initVideo() {
    window._wq = window._wq || [];
    window._wq.push({
      id: this.videoId,
      onReady: (video: WistiaVideoType) => {
        this.disableInteractions();

        this.video = video;
        (this.dom.playButton as HTMLButtonElement).disabled = false;
      }
    });
  }

  playVideo() {
    this.video?.play();
    requestAnimationFrame(() => {
      (this.dom.pictureEl as HTMLElement).style.opacity = '0';
      (this.dom.playButton as HTMLElement).style.display = 'none';
      this.enableInteractions();

      setTimeout(() => {
        (this.dom.videoWrapper as HTMLElement).style.zIndex = '0';
      },300);
    });
  }
}

export default mediaCarouselCard;
